import { render, staticRenderFns } from "./RespondersList.vue?vue&type=template&id=652eac12&scoped=true"
import script from "./RespondersList.vue?vue&type=script&lang=js"
export * from "./RespondersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652eac12",
  null
  
)

export default component.exports